// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"input-year_inputContainer__S5KZR"};